
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/newsroom/[slug]",
      function () {
        return require("private-next-pages/newsroom/[slug]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/newsroom/[slug]"])
      });
    }
  